import Axios from "../../../lib/Axios";

/**
 * Pending Broadcasts API Helper
 * 
 * API functions for pending broadcasts page
 */

/**
 * Get pending broadcasts list
 * @returns {Promise} API response with broadcasts array and pagination
 */
export const getPendingBroadcastsList = async () => {
  // GET /admin/broadcasts/pending-review
  const result = await Axios.get("admin/broadcasts/pending-review");
  const broadcasts = result?.data?.result?.broadcasts || [];
  const pagination = result?.data?.result?.pagination || {};
  
  return {
    data: broadcasts,
    pagination: {
      currentPage: pagination.currentPage || 1,
      limit: pagination.limit || 50,
      totalPages: pagination.totalPages || 1,
      totalRecords: pagination.totalRecords || 0,
    },
  };
};

/**
 * Approve a broadcast
 * @param {string} broadcast_id - The broadcast ID to approve
 * @returns {Promise} API response
 */
export const approveBroadcast = async (broadcast_id) => {
  if (!broadcast_id) {
    throw new Error("broadcast_id is required");
  }

  // POST /admin/broadcasts/{broadcast_id}/approve
  const result = await Axios.post(`admin/broadcasts/${broadcast_id}/approve`);
  
  return result;
};

/**
 * Reject a broadcast
 * @param {Object} data - Reject data
 * @param {string} data.broadcast_id - The broadcast ID to reject
 * @param {string} data.adminExpirationText - Admin rejection reason
 * @returns {Promise} API response
 */
export const rejectBroadcast = async (data) => {
  const { broadcast_id, adminExpirationText } = data;
  
  if (!broadcast_id) {
    throw new Error("broadcast_id is required");
  }
  if (!adminExpirationText) {
    throw new Error("adminExpirationText is required");
  }

  // POST /admin/broadcasts/{broadcast_id}/reject
  const result = await Axios.post(`admin/broadcasts/${broadcast_id}/reject`, {
    adminExpirationText,
  });
  
  return result;
};

/**
 * Suspend a broadcast
 * @param {Object} data - Suspend data
 * @param {string} data.broadcast_id - The broadcast ID to suspend
 * @param {string} data.adminExpirationText - Admin suspension reason
 * @returns {Promise} API response
 */
export const suspendBroadcast = async (data) => {
  const { broadcast_id, adminExpirationText } = data;
  
  if (!broadcast_id) {
    throw new Error("broadcast_id is required");
  }
  if (!adminExpirationText) {
    throw new Error("adminExpirationText is required");
  }

  // POST /admin/broadcasts/{broadcast_id}/suspend
  const result = await Axios.post(`admin/broadcasts/${broadcast_id}/suspend`, {
    adminExpirationText,
  });
  
  return result;
};

